import { useApiMutation } from "./use-api-mutation";
import { useQueryClient } from "@tanstack/react-query";

export default function useActivateSizingExperiment(shopId: string) {
	const queryClient = useQueryClient();

	return useApiMutation(
		"post",
		"/shops/{shopId}/sizing/experiments/{experimentId}/activate",
		{
			invalidate: () => {
				queryClient.invalidateQueries({
					queryKey: ["get", "/shops/{shopId}/sizing/experiments"],
				});
			},
			mapVariables: (variables: { experimentId: string }) => ({
				params: {
					path: { shopId, experimentId: variables.experimentId },
				},
			}),
		},
	);
}
